/**
 * Add support for boolean logic operations to subscribables here
 */
define('common/ko/fn/logic',['knockout'], function(ko) {

    ko.subscribable.fn.inverted = function () {
        var original = this;
        return ko.pureComputed(function () { return !original(); });
    };

    ko.subscribable.fn.toBoolean = function () {
        var original = this;
        return ko.pureComputed(function () { return !!original(); });
    };

    ko.subscribable.fn.increment = function(value) {
        this(this() + (value || 1));
        return this;
    };
});

